<template>
	<div>
		<Navbar></Navbar>
		<div class="main-content">

			<Loader :show="loading"></Loader>
			<div class="container mt-3" v-if="!loading">
				<div class="row">
					<div class="col mb-4">
						<div class="d-flex justify-content-between align-items-center">

							<h3>Dashboard</h3>

							<div style="width: 230px;">
								<date-picker 
									v-model="dateRange" 
									type="date" 
									@change="changeDate()" 
									range 
									placeholder="Filtrar por rango de fechas"
									value-type="YYYY-MM-DD" 
									format="DD-MM-YYYY"
								></date-picker>
							</div>
							
						</div>
					</div>
				</div>


				<div class="row mb-4">
					<div class="col-12 col-md-6">
						<div class="boxes">
							<router-link tag="div" to="/cars?status=PRE_ADMITTED" class="box" style="background-color:rgb(73, 143, 243);">
								<div class="number">{{data.totals.carsPreAdmited}}</div>
								<div class="label">Pre admitidos</div>
							</router-link>
							<!-- <router-link tag="div" to="/cars?status=IN_CUSTOMS_DEPOSIT" class="box" style="background-color:rgb(255, 197, 110);">
								<div class="number">{{data.totals.carsInCustomsDeposit}}</div>
								<div class="label">En depósito fiscal</div>
							</router-link> -->
							<router-link tag="div" to="/cars?status=CUSTOMS_DISPATCHED" class="box" style="background-color:rgb(247, 186, 95);">
								<div class="number">{{data.totals.carsCustomsDispatchPending}}</div>
								<div class="label">Despachados en fiscal</div>
							</router-link>
							<!-- <router-link tag="div" to="/cars?status=IN_NATIONAL_DEPOSIT" class="box" style="background-color:#2dcc70">
								<div class="number">{{data.totals.carsInNationalDeposit}}</div>
								<div class="label">En depósito nacional</div>
							</router-link> -->
							<router-link tag="div" to="/cars?status=PRE_DELIVERY_PENDING" class="box" style="background-color:rgb(105, 214, 151);">
								<div class="number">{{data.totals.carsPreDeliveryPending}}</div>
								<div class="label">Pendientes de pre entrega</div>
							</router-link>
							<!-- <router-link tag="div" to="/cars?status=PRE_DELIVERY_DONE" class="box" style="background-color:rgb(72, 241, 143)">
								<div class="number">{{data.totals.carsPreDeliveryDone}}</div>
								<div class="label">Pre entegas realizadas</div>
							</router-link> -->
							<router-link tag="div" to="/cars?status=DELIVERY_REQUESTED" class="box" style="background-color:rgb(72, 241, 143)">
								<div class="number">{{data.totals.carsDeliveryRequested}}</div>
								<div class="label">Pendientes de programar entrega</div>
							</router-link>
							<router-link tag="div" to="/cars?status=DELIVERY_SCHEDULED" class="box" style="background-color:#1bbc9b">
								<div class="number">{{data.totals.carsDeliveryScheduled}}</div>
								<div class="label">Entregas programadas</div>
							</router-link>
						</div>
					</div>
					<div class="col-12 col-md-6 d-flex">
						<div class="chart-box">
							<h4>Depósito fiscal</h4>
							<vc-donut :sections="occupationChartFiscal" :size="120" class="mt-4 mb-4">
								OCUPACIÓN
								<h4>{{data.parkingOccupation.fiscal.percent}}%</h4>
							</vc-donut>
							<p>PLAZAS: {{data.parkingOccupation.fiscal.total}}</p>
							<p>VEHÍCULOS: {{data.parkingOccupation.fiscal.cars}}</p>
						</div>
						<div class="chart-box">
							<h4>Depósito nacional</h4>
							<vc-donut :sections="occupationChartNational" :size="120" class="mt-4 mb-4">
								OCUPACIÓN
								<h4>{{data.parkingOccupation.national.percent}}%</h4>
							</vc-donut>
							<p>PLAZAS: {{data.parkingOccupation.national.total}}</p>
							<p>VEHÍCULOS: {{data.parkingOccupation.national.cars}}</p>
						</div>
					</div>
				</div>

				<div class="row ">
					<div class="col col-12 ">
						<div class="bg-white">
							
							<b-tabs content-class="" @activate-tab="activateTab" v-if="!loading">

								<b-tab title="A ingresar" active>
									<div class="p-4">
										
										<h4>Vehículos a ingresar</h4>

										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

										<table class="table table-clickeable mt-4" v-if="!loadingTab && carsToAdmit.length>0">
											<tr class="table-head">
												<td></td>
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Ingresa a</td>
												<td>Fecha de ingreso</td>
											</tr>
											
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsToAdmit" :key="item.id" >
												<td>
													<div class="tc">
														<span class="text-primary">{{item.typeText}}</span>
														<span >{{item.description}}</span>
													</div>
												</td>
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.deposit.title}}</span>
														<!-- <span >STOCK: {{item.dua_stock}}</span> -->
													</div>
												</td>
												<td>
													<div class="tc">
														<span v-if="item.admission_estimated_at" style="margin-left: 15px;">
															{{item.admission_estimated_at | moment("DD-MM-YYYY")}}
														</span>

													</div>
												</td>
											</router-link>
										</table>

										<div class="alert alert-warning m-5 mb-2 text-center" v-if="!loadingTab && carsToAdmit.length==10">
											Mostrando un máximo de 10 resultados, para ver todos haga <router-link tag="a" to="/cars?status=PRE_ADMITTED"> click aquí</router-link>
										</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && carsToAdmit.length==0">No se han encontrado vehículos a ingresar</div>
										
									</div>
								</b-tab>

								<b-tab title="A despachar">
									<div class="p-4">
										<h4>Vehículos a despachar</h4>
										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>
										<table class="table table-clickeable mt-4" v-if="!loadingTab && carsToDispatch.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Despacho</td>
												<td></td>
											</tr>
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsToDispatch" :key="item.id" >
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.dua_dispatch}}</span>
														<a class="" target="_blank" v-if="item.dispatch_file" :href="API_URL+item.dispatch_file.url">
															{{item.dispatch_file.filename}}.{{item.dispatch_file.extension}}
														</a>
													</div>
												</td>
												<td>
													<div class="tc" v-if="item.dispatch_requested_at">
														<span>Solicitado el</span>
														<span>
															{{item.dispatch_requested_at | moment("DD-MM-YYYY")}}
														</span>
													</div>
												</td>
											</router-link>
										</table>
										<div class="alert alert-warning m-5 mb-2 text-center" v-if="!loadingTab && carsToDispatch.length==10">
											Mostrando un máximo de 10 resultados, para ver todos haga <router-link tag="a" to="/cars?status=CUSTOMS_DISPATCHED"> click aquí</router-link>
										</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && carsToDispatch.length==0">No se han encontrado vehículos a despachar</div>
									</div>
								</b-tab>

								<b-tab title="A pre entregar">
									<div class="p-4">
										<div class="d-flex justify-content-between align-items-center">
											<h4>Vehículos pendientes de pre entrega</h4>

											<!-- <div style="width: 230px;">
												<date-picker 
													v-model="dateRange" 
													type="date" 
													@change="changeDate()" 
													range 
													placeholder="Filtrar por rango de fechas"
													value-type="YYYY-MM-DD" 
													format="DD-MM-YYYY"
												></date-picker>
											</div> -->
										</div>

										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

										<table class="table table-clickeable mt-4" v-if="!loadingTab && carsToPreDelivery.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td></td>
											</tr>
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsToPreDelivery" :key="item.id" >
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc" v-if="item.pre_delivery_requested_at">
														<span>Solicitada el</span>
														<span>
															{{item.pre_delivery_requested_at | moment("DD-MM-YYYY")}}
														</span>
													</div>
												</td>
											</router-link>
										</table>

										<div class="alert alert-warning m-5 mb-2 text-center" v-if="!loadingTab && carsToPreDelivery.length==10">
											Mostrando un máximo de 10 resultados, para ver todos haga <router-link tag="a" to="/cars?status=PRE_DELIVERY_PENDING"> click aquí</router-link>
										</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && carsToPreDelivery.length==0">No se han encontrado vehículos para pre entregar</div>
									</div>
								</b-tab>

								<b-tab title="A entregar">
									<div class="p-4">
										<div class="d-flex justify-content-between align-items-center">
											<h4>Vehículos a entregar</h4>

											<!-- <div style="width: 230px;">
												<date-picker 
													v-model="dateRange" 
													type="date" 
													@change="changeDate()" 
													range 
													placeholder="Filtrar por rango de fechas"
													value-type="YYYY-MM-DD" 
													format="DD-MM-YYYY"
												></date-picker>
											</div> -->
										</div>

										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>


										<table class="table table-clickeable mt-4" v-if="!loadingTab && carsToDelivery.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Despacho</td>
												<td>Entrega a</td>
											</tr>
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsToDelivery" :key="item.id" >
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
														<span v-if="item.status == 'DELIVERY_SCHEDULED' && item.delivery_scheduled_at" style="margin-left: 15px;">
															Fecha de entrega progr: {{item.delivery_scheduled_at | moment("DD-MM-YYYY [a las] HH:mm")}}
														</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span>{{item.delivery_to_business}}</span>
														<span>{{item.delivery_to_carrier}}</span>
													</div>
												</td>
											</router-link>
										</table>

										<div class="alert alert-warning m-5 mb-2 text-center" v-if="!loadingTab && carsToDelivery.length==10">
											Mostrando un máximo de 10 resultados, para ver todos haga <router-link tag="a" to="/cars?status=DELIVERY_SCHEDULED"> click aquí</router-link>
										</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && carsToDelivery.length==0" >No se han encontrado vehículos para entregar</div>
									</div>
								</b-tab>
								
								<b-tab title="Sin lugar asignado">
									<div class="p-4">
										<h4>Vehículos sin lugar asignado</h4>

										<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

										<table class="table table-clickeable mt-4" v-if="!loadingTab && carsWithoutSlot.length>0">
											<tr class="table-head">
												<td>Chasis</td>
												<td>Vehículo</td>
												<td>Cliente</td>
												<td>Estado</td>
											</tr>
											
											<router-link tag="tr" :to="`/cars/${item.id}`" v-for="item of carsWithoutSlot" :key="item.id">
												<td>{{item.chassis_number}}</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.brand.title}}</span>
														<span >{{item.model}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span class="text-primary">{{item.client.name}}</span>
														<span >{{item.client.business_name}}</span>
													</div>
												</td>
												<td>
													<div class="tc">
														<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
														<span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span>
													</div>
												</td>
											</router-link>
										</table>

										<div class="alert alert-warning m-5 mb-2 text-center" v-if="!loadingTab && carsWithoutSlot.length==10">
											Mostrando un máximo de 10 resultados, para ver todos haga <router-link tag="a" to="/cars?status=WITHOUT_SLOT"> click aquí</router-link>
										</div>

										<div class="alert alert-light text-center" v-if="!loadingTab && carsWithoutSlot.length==0" >No se han encontrado vehículos sin lugar asignado</div>
									</div>
								</b-tab>

							</b-tabs>

						</div>

					</div>

				</div>
			</div>

		</div>
	</div>
</template>


<script>
import gql from 'graphql-tag'
// import { mapState } from 'vuex'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

export default {
	name: 'dashboard',
	components: {
		Navbar,
		Loader
	},
	data(){
		return{
			data: null,
			loading: true,
			dateRange: [],
			API_URL: process.env.VUE_APP_API_URL,
			occupationChartFiscal: [],
			occupationChartNational: [],
			loadingTab: false,
			carsToAdmit:[],
			carsToDispatch:[],
			carsToPreDelivery:[],
			carsToDelivery:[],
			carsWithoutSlot:[],
			activeTabIndex: null
		}
	},
	beforeMount(){
		if(this.$route.query.from){
			this.dateRange[0] = this.$route.query.from
			this.dateRange[1] = this.$route.query.to
		}
		this.load()
		this.loadCarsToAdmit()
	},
	mounted(){
		setInterval(()=>{
			this.load()
		}, 60000)
	},
	methods:{
		activateTab(newTabIndex ){
			if(newTabIndex == 0){ this.loadCarsToAdmit() }
			if(newTabIndex == 1){ this.loadCarsToDispatch() }
			if(newTabIndex == 2){ this.loadCarsToPreDelivery() }
			if(newTabIndex == 3){ this.loadCarsDelivery() }
			if(newTabIndex == 4){ this.loadCarsWithoutSlot() }
		},
		load(){
			this.$apollo.query({
				query: gql`query  ($from: Date, $to: Date){
					adminDashboard (from: $from, to: $to) {
						totals{
							carsPreAdmited
							carsInCustomsDeposit
							carsCustomsDispatchPending
							carsInNationalDeposit
							carsPreDeliveryPending
							carsPreDeliveryDone
							carsDeliveryScheduled
							carsDeliveryRequested
						}
						parkingOccupation{
							fiscal
							national
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					from: this.$route.query.from,
					to: this.$route.query.to,
				},
			})
			.then((data) => {
				this.data = data.data.adminDashboard;
				if(data.data.adminDashboard.parkingOccupation.fiscal.percent>100){
					data.data.adminDashboard.parkingOccupation.fiscal.percent = 100
				}
				this.occupationChartFiscal = [{ value: parseInt(data.data.adminDashboard.parkingOccupation.fiscal.percent), color: 'rgb(255, 174, 52)'}]
				if(data.data.adminDashboard.parkingOccupation.national.percent>100){
					data.data.adminDashboard.parkingOccupation.national.percent = 100
				}
				this.occupationChartNational = [{ value: parseInt(data.data.adminDashboard.parkingOccupation.national.percent), color: '#20d6ac' }]
				this.loading = false
			});
		},
		loadCarsToAdmit(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String, $admission_estimated_from: Date, $admission_estimated_to: Date){
					cars ( first: $first, status: $status, admission_estimated_from: $admission_estimated_from, admission_estimated_to: $admission_estimated_to ){
						data{
							id
							chassis_number
							model
							brand{ title }
							deposit{ title }
							client{ name business_name }
							admission_estimated_at
							dua_transit
							dua_stock
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'PRE_ADMITTED',
					admission_estimated_from: this.dateRange[0],
					admission_estimated_to: this.dateRange[1]
				},
			})
			.then((data) => {
				this.carsToAdmit = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadCarsToDispatch(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String, $dispatch_requested_from: Date, $dispatch_requested_to:Date){
					cars ( first: $first, status: $status, dispatch_requested_from:$dispatch_requested_from, dispatch_requested_to: $dispatch_requested_to ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							dua_dispatch
							dispatch_file{ id filename extension url }
							dispatch_requested_at
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'CUSTOMS_DISPATCHED',
					dispatch_requested_from: this.dateRange[0],
					dispatch_requested_to: this.dateRange[1]
				},
			})
			.then((data) => {
				this.carsToDispatch = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadCarsToPreDelivery(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					cars ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							pre_delivery_requested_at
							status
							statusText
							
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'PRE_DELIVERY_PENDING'
				},
			})
			.then((data) => {
				this.carsToPreDelivery = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadCarsDelivery(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					cars ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							status
							statusText
							delivery_scheduled_at
							delivery_to_business
							delivery_to_carrier
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'DELIVERY_SCHEDULED'
				},
			})
			.then((data) => {
				this.carsToDelivery = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadCarsWithoutSlot(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					cars ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							status
							statusText
							delivery_scheduled_at
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'WITHOUT_SLOT'
				},
			})
			.then((data) => {
				this.carsWithoutSlot = data.data.cars.data;
				this.loadingTab = false
			});
		},
		
		changeDate(){
			if(this.dateRange && this.dateRange[0]){
				this.$router.replace({ name:'Dashboard', query: {from:this.dateRange[0],to:this.dateRange[1]} } );
			}else{
				this.$router.replace({name:'Dashboard', path:'/',query:{}})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.chart-box{
	margin: 2px;
	padding: 16px 8px;
	
	background-color: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
	cursor: pointer;
	transition: all .3s;
}
.chart-box h4{
	font-size: 1.2rem;
}

.boxes{
	display: flex;
	width: 100%;
	height: 100%;
	flex-wrap: wrap;
	align-items: center;

	.box{
		margin: 2px;
		padding: 16px 8px;
		
		background-color: #333;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;
		color: #fff;
		cursor: pointer;
		transition: all .3s;

		.number{
			font-size: 1.6rem;
			font-weight: 600;;
		}
		.label{
			font-size: .7rem;
			font-weight: 400;
			text-align: center;
		}
	}
	.box:hover{
		background-color: #d7e7f5;
	}
}



</style>
